const contactTrad = {
    fr: {
        reseaux: "Réseaux sociaux",
        contact: "Contact",
        texte: "Contactez moi par mail : ",
        bouton: "TELECHARGER CV",
    },
    en: {
        reseaux: "Social Networks",
        contact: "Contact",
        texte: "Contact me by email : ",
        bouton: "DOWNLOAD CV",
    },
};

export default contactTrad;
